import { render, staticRenderFns } from "./ResetPassword.vue?vue&type=template&id=d7239aea&scoped=true&"
import script from "./ResetPassword.vue?vue&type=script&lang=ts&"
export * from "./ResetPassword.vue?vue&type=script&lang=ts&"
import style0 from "./ResetPassword.vue?vue&type=style&index=0&id=d7239aea&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7239aea",
  null
  
)

export default component.exports